export default {"src":"/_next/static/media/diamond-ring.e9634c0e.svg","height":42,"width":34};